<template>
  <div class="holiday">
    <div class="hd ly-card">
      <el-button class="fl" @click="openDigFrom(true)" type="primary" v-if="hasPermission('holiday_add')"
        >新增</el-button
      >
      <div class="fr">
        <el-input v-model.trim="searchFormData.year" placeholder="学年（例：2019）"></el-input>
        <el-input v-model.trim="searchFormData.name" placeholder="假日名称"></el-input>
        <el-button @click="search" type="primary">查询</el-button>
      </div>
    </div>
    <ly-table
      :getTableData="getTableData"
      :tableHeader="tableHeader"
      :searchFormData="searchFormData"
      ref="lyTable"
      class="ly-card"
    >
      <template v-slot:activate_status="row">
        <el-button
          @click="statusRow(row, row.activate_status)"
          type="text"
          :class="row.activate_status && 'el-button--danger'"
          size="mini"
          >{{ row.activate_status ? '禁用' : '启用' }}</el-button
        >
      </template>
      <template v-slot:action="row">
        <template>
          <el-button @click="editRow(row)" type="primary" v-if="hasPermission('holiday_edit')" size="mini"
            >编辑</el-button
          >
          <el-button @click="delRow(row)" type="danger" v-if="hasPermission('holiday_delete')" size="mini"
            >删除</el-button
          >
        </template>
      </template>
    </ly-table>
    <el-dialog
      :title="`${defaultFormItem.id ? '修改' : '新增'}假日`"
      :visible.sync="dialogVisible"
      width="530px"
      @opened="openEvent"
    >
      <ly-form :defaultFormItem="defaultFormItem" :formConfig="formConfig" :formKeys="formKeys" ref="lyForm"></ly-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addHoliday">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { Dialog, Input } from 'element-ui';
import LyTable from '@/components/LyTable';
import LyForm from '@/components/LyForm';
import { holidayTable } from '@/utils/tableHeader';
import { holidayFormItem } from '@/utils/formConfig';
import { sys } from '@/api';
import perMixin from '@/utils/perMixin';

export default {
  name: 'Holiday',
  mixins: [perMixin],
  components: {
    LyTable,
    LyForm,
    ElInput: Input,
    ElDialog: Dialog
  },
  data() {
    return {
      dialogVisible: false,
      formKeys: {},
      defaultFormItem: {},
      formConfig: {
        'label-width': '120px',
        'label-position': 'left',
        ref: 'ly-form',
        itemSpan: 24
      },
      searchFormData: {
        name: '',
        year: ''
      },
      tableHeader: holidayTable,
      getTableData: sys.getHoliday
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.search();
      const { year } = await this.$store.dispatch('schoolYear/getTermAndYearList');
      holidayFormItem.year.options.select = year;
      this.formKeys = holidayFormItem;
    },
    openEvent() {
      this.$refs.lyForm.$refs.lyForm.clearValidate();
    },
    search() {
      const { year } = this.searchFormData;
      if (year && (year.length !== 4 || !parseInt(year, 10))) {
        this.$message.warning('年份填写错误！');
        return;
      }
      this.$refs.lyTable.setData();
    },
    openDigFrom(isAdd) {
      this.dialogVisible = true;
      if (isAdd) {
        this.defaultFormItem = {};
      }
    },
    async addHoliday() {
      const { data, valid } = await this.$refs.lyForm.getFormData();
      if (valid) {
        let res = null;
        if (this.defaultFormItem.id) {
          // 修改
          res = await sys.controlHoliday({
            methold: 'put',
            id: this.defaultFormItem.id,
            params: {
              ...data,
              start_date: data.date[0],
              end_date: data.date[1]
            }
          });
          if (res) this.$store.dispatch('msg/showMsg', res.msg || '修改成功');
        } else {
          // 新增
          res = await sys.holiday({
            params: {
              ...data,
              start_date: data.date[0],
              end_date: data.date[1]
            },
            methold: 'post'
          });
          if (res) this.$store.dispatch('msg/showMsg', res.msg || '新增成功');
        }
        if (res) {
          this.$refs.lyTable.setData();
          this.dialogVisible = false;
        }
      }
    },
    delRow(row) {
      this.$confirm('确认删除？')
        .then(() => {
          sys
            .controlHoliday({
              methold: 'delete',
              id: row.id
            })
            .then(res => {
              this.search();
              this.$store.dispatch('msg/showMsg', res.msg || '删除成功');
            });
        })
        .catch(() => {});
    },
    editRow(row) {
      this.defaultFormItem = { ...row, date: [row.start_date, row.end_date] };
      this.openDigFrom();
    }
  }
};
</script>

<style lang="less">
.holiday {
  .hd {
    overflow: hidden;
    .el-input {
      width: 200px;
      margin-right: 20px;
    }
  }
  .ly-form .el-input {
    width: 350px;
  }
}
</style>
